import React, { PureComponent, KeyboardEvent } from 'react';
import { TextField, InputAdornment, IconButton, Grid } from '@mui/material';
import { Tooltip } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

interface ScheduleFilterProps {
  filterText: string;
  updateFilter: (filter: string) => void;
  loadSchedule: (forceRefresh: boolean) => Promise<void>;
}

export default class ScheduleFilter extends PureComponent<ScheduleFilterProps> {
  handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      (event.target as HTMLDivElement).blur();
    }
  };

  render() {
    return (
      <Tooltip
        style={{ fontSize: 30 }}
        title={
          <h3>
            Filter by job name, Rogo Job ID, or use has:points, has:zones, or has:cores+zones for special filtering.
          </h3>
        }
      >
        <Grid style={{ textAlign: 'center' }} size={12}>
          <TextField
            type="text"
            label="filter..."
            value={this.props.filterText}
            onChange={(e) => {
              this.props.updateFilter(e.target.value);
            }}
            inputProps={{ enterKeyHint: 'search' }}
            style={{ width: '95%' }}
            onKeyDown={this.handleKeyDown}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={async () => {
                      this.props.loadSchedule(true);
                    }}
                    data-testid="job-browser-refresh"
                    size="large"
                  >
                    <RefreshIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Tooltip>
    );
  }
}
